import { UserRolePermission } from '@schooly/api';
import { useAuth } from '@schooly/components/authentication';

export const TIMETABLE_VIEW_PERMISSIONS: UserRolePermission[] = ['timetable_viewer'];
export const TIMETABLE_MANAGE_PERMISSIONS: UserRolePermission[] = ['timetable_manager'];

export const TIMETABLE_ACCESS_PERMISSIONS: UserRolePermission[] = [
  ...TIMETABLE_VIEW_PERMISSIONS,
  ...TIMETABLE_MANAGE_PERMISSIONS,
];

export function useTimetablePermissions() {
  const { permissions } = useAuth();

  const canViewTimetables = TIMETABLE_ACCESS_PERMISSIONS.some((p) => permissions.includes(p));
  const canManageTimetables = TIMETABLE_MANAGE_PERMISSIONS.some((p) => permissions.includes(p));

  return { canViewTimetables, canManageTimetables };
}
